//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import FrontConfigAccesses from '~/views/FrontConfig/FrontConfigAccesses/FrontConfigAccesses.vue';

export default {
  components: {
    FrontConfigAccesses,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadAccesses(),
      this.loadAppList(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('frontConfigAccesses', {
      loadAccesses: 'loadData',
      loadAppList: 'loadAppList',
    }),
  },
};
